import { useContext } from 'react';
import { resultsInterface } from '../../lib/type';
import './Results.scss';
import { layoutContext } from '../Context/RoiCalculator';

const Results = (resultsProps: { contents: resultsInterface }) => {
  const { contents } = resultsProps;
  const { output } = useContext(layoutContext);

  return (
    <div className="bx--grid roi-calculator__results">
      <div className="bx--row">
        <div className="bx--col-lg-10 bx--col-md-6 bx--col-sm-4 roi-calculator__results-content">
          <h2 className="roi-calculator__results-title">
            {contents.resultsTitle}*
          </h2>
          <h4 className="roi-calculator__results-subtitle">
            {contents.resultsText}
          </h4>
          <div className="bx--row roi-calculator__results-output">
            <div className="bx--col-lg-8 bx--col-md-4 roi-calculator__results-output-texts">
              <p className="roi-calculator__results-output-text">
                {contents.reduce1}
              </p>
              <p className="roi-calculator__results-output-text">
                {contents.reduce2}
              </p>
              <p className="roi-calculator__results-output-text">
                {contents.reduce3}
              </p>
              <p className="roi-calculator__results-output-text-final">
                {contents.savings}
              </p>
            </div>
            <div className="bx--col-lg-8 bx--col-md-4 roi-calculator__results-output-numbers">
              <p className="roi-calculator__results-output-number">{`USD $ ${output.minSavingsBySelfServicedQueriesPerYear.toLocaleString()} – ${output.maxSavingsBySelfServicedQueriesPerYear.toLocaleString()}`}</p>
              <p className="roi-calculator__results-output-number">{`USD $ ${output.reduceTheTicketsRaisedMin.toLocaleString()} – ${output.reduceTheTicketsRaisedMax.toLocaleString()}`}</p>
              <p className="roi-calculator__results-output-number">{`USD $ ${output.improveProductivityMin.toLocaleString()} – ${output.improveProductivityMax.toLocaleString()}`}</p>
              <p className="roi-calculator__results-output-number-final">
                {`USD $ ${output.hrTotalSavingsMin.toLocaleString()} - ${output.hrTotalSavingsMax.toLocaleString()}`}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Results;
